<div *ngIf="loadData" class="learn-urban mb-3">
  <div class="d-flex align-items-center gap-2">
      <h1 class="f-20 fw-600 color-000 mb-0">{{ merchantName | translate | async}}</h1>
      <img src="assets\images\merchants-img\learn.svg" alt="">
  </div>
  <div>
      <button (click)="selectTab(1)" class="tab11 f-14 fw-600" [class.active]="selectedTab === 1">{{'Overview' | translate | async}}</button>
      <!-- <button (click)="selectTab(2)" class="tab11 f-14 fw-600" [class.active]="selectedTab === 2">{{'Sales'| translate | async}}</button> -->
      <button (click)="selectTab(3)" class="tab11 f-14 fw-600" [class.active]="selectedTab === 3">{{'Payment Integration' | translate | async}}</button>
      <button (click)="selectTab(4)" class="tab11 f-14 fw-600" [class.active]="selectedTab === 4">{{'Users' | translate | async}}</button>
      <button (click)="selectTab(5)" class="tab11 f-14 fw-600" [class.active]="selectedTab === 5">{{'Orders' | translate | async}}</button>
      <!-- <button (click)="selectTab(6)" class="tab11 f-14 fw-600" [class.active]="selectedTab === 6">{{'Transactions' | translate | async}}</button> -->
  </div>
</div>
<ng-template #showInviteEmployeeModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{'Invite a new employee' | translate | async}}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <form
      [formGroup]="newPageForm"
      (ngSubmit)="onSave()"
      (keydown.enter)="$event.preventDefault()"
      autocomplete="off"
    >
      <div formGroupName="employeeInfoData">

        <!-- First Name -->
        <div class="mb-3 row align-items-center">
          <label for="firstname" class="col-sm-5 col-form-label">
            {{"First Name*" | translate | async}}
          </label>
          <div class="col-sm-7">
            <input
              type="text"
              class="form-control"
              id="firstname"
              placeholder="{{'First name' | translate | async}}"
              formControlName="fname"
            />
            <div
              class="text-danger"
              *ngIf="
                newPageForm.get('employeeInfoData.fname')?.touched &&
                newPageForm.get('employeeInfoData.fname')?.invalid
              "
            >
              <div *ngIf="newPageForm.get('employeeInfoData.fname').errors?.['required']">
                <h6 class="text-danger form-text">
                  {{ 'Employee First Name is required.' | translate | async }}
                </h6>
              </div>
            </div>
          </div>
        </div>

        <!-- Last Name -->
        <div class="mb-3 row align-items-center">
          <label for="lastname" class="col-sm-5 col-form-label">
            {{ 'Last Name*' | translate | async }}
          </label>
          <div class="col-sm-7">
            <input
              type="text"
              class="form-control"
              id="lastname"
              placeholder="{{'Last name' | translate | async}}"
              formControlName="lname"
            />
            <div
              class="text-danger"
              *ngIf="
                newPageForm.get('employeeInfoData.lname').touched &&
                newPageForm.get('employeeInfoData.lname').invalid
              "
            >
              <div *ngIf="newPageForm.get('employeeInfoData.lname').errors?.['required']">
                <h6 class="text-danger form-text">
                  {{ 'Employee Last Name is required.' | translate | async }}
                </h6>
              </div>
            </div>
          </div>
          </div>

          <!-- Dashboard access  -->
          <div class="mb-3 row align-items-center">
            <label for="DashboardAccess" class="col-sm-5 col-form-label">
              {{ 'Dashboard Access' | translate | async }}
              <i style="cursor: pointer"
                [ngbPopover]="'Enabling Dashboard Access will allow the employee to view and edit modules on the online dashboard.' | translate | async"
                triggers="mouseenter:mouseleave" placement="right">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.0001 18.3366C5.39771 18.3366 1.66675 14.6056 1.66675 10.0033C1.66675 5.40088 5.39771 1.66992 10.0001 1.66992C14.6024 1.66992 18.3334 5.40088 18.3334 10.0033C18.3334 14.6056 14.6024 18.3366 10.0001 18.3366ZM10.0001 16.6699C13.682 16.6699 16.6667 13.6852 16.6667 10.0033C16.6667 6.32135 13.682 3.33659 10.0001 3.33659C6.31818 3.33659 3.33341 6.32135 3.33341 10.0033C3.33341 13.6852 6.31818 16.6699 10.0001 16.6699ZM9.16675 5.83659H10.8334V7.50325H9.16675V5.83659ZM9.16675 9.16992H10.8334V14.1699H9.16675V9.16992Z"
                    fill="#666666" />
                </svg>
              </i>
            </label>
            <div class="col-sm-7">
              <div class="input-group align-items-center">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" formControlName="dashboardAccess" />
                </div>
              </div>
              <p class="f-12 fw-400 m-0 p-grey emp-pho">
                {{ 'Please note that if the dashboard access is not to be provided to an employee, then the email and phone number is optional.' | translate | async }}
              </p>
            </div>
          </div>

          <!-- Email -->
          <div class="mb-3 row align-items-center" *ngIf="newPageForm?.get('employeeInfoData.dashboardAccess').value">
            <label for="Email" class="col-sm-5 col-form-label">
              {{ 'Email*' | translate | async }}
            </label>
            <div class="col-sm-7">
              <input type="text" class="form-control" id="Email" placeholder="{{'Email' | translate | async}}"
                formControlName="mail" />
              <div class="text-danger" *ngIf="
                  newPageForm.get('employeeInfoData.mail').touched &&
                  newPageForm.get('employeeInfoData.mail').invalid
                ">
                <div *ngIf="newPageForm.get('employeeInfoData.mail').errors?.['required']">
                  <h6 class="text-danger form-text">
                    {{ 'mail is required.' | translate | async }}
                  </h6>
                </div>
                <div *ngIf="newPageForm.get('employeeInfoData.mail').errors?.['email']">
                  <h6 class="text-danger form-text">
                    {{ 'Invalid email format.' | translate | async }}
                  </h6>
                </div>
              </div>
            </div>
          </div>

          <!-- phone number  -->
          <div class="mb-3 row align-items-center" *ngIf="newPageForm?.get('employeeInfoData.dashboardAccess').value">
            <label for="Phone" class="col-sm-5 col-form-label">
              {{ 'Phone' | translate | async }}<span>*</span>
            </label>
            <div class="col-sm-7">
              <div class="input-group">
                <ngx-intl-tel-input [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
                  [enablePlaceholder]="true" [searchCountryFlag]="true" [customPlaceholder]="placeholderPhone"
                  [searchCountryField]="[
                    SearchCountryField?.Iso2,
                    SearchCountryField.Name
                  ]" [selectFirstCountry]="true" [maxLength]="10" [phoneValidation]="true" [separateDialCode]="true"
                  [inputId]="'inputPhone'" name="phoneNumber" formControlName="phoneNumber">
                </ngx-intl-tel-input>
              </div>
            </div>
          </div>


          <!-- Employee Role -->
          <div class="mb-3 row align-items-center">
            <label for="role" class="col-sm-5 col-form-label">
              {{ 'Employee Role*' | translate | async }}
            </label>
            <div class="col-sm-7">
              <ng-select class="form-control" id="role" placeholder="Select employee role" formControlName="role"
                [clearable]="false">
                <ng-option value="">
                  {{ 'Select employee role' | translate | async }}
                </ng-option>
                <ng-option *ngFor="let role of roles" [value]="role?.roleId">
                  {{ role.roleName | translate | async }}
                </ng-option>
              </ng-select>
              <div class="text-danger" *ngIf="
                          newPageForm.get('employeeInfoData.role').touched &&
                          newPageForm.get('employeeInfoData.role').invalid
                        ">
                <div *ngIf="newPageForm.get('employeeInfoData.role').errors?.['required']">
                  <h6 class="text-danger form-text">
                    {{ 'Please select a role.' | translate | async }}
                  </h6>
                </div>
              </div>
            </div>
          </div>


        <!-- Revenue Center -->
        <div class="mb-3 row align-items-center">
          <label for="revenueCenters" class="col-sm-5 col-form-label">
            {{ 'Revenue Center*' | translate | async }}
          </label>
          <div class="col-sm-7">
            <ng-multiselect-dropdown
              class="form-control"
              id="revenueCenters"
              [placeholder]="'Select Revenue Centers' | translate | async"
              [settings]="dropdownSettings1"
              [data]="revenueCenters"
              formControlName="revenueCenters"
            >
            </ng-multiselect-dropdown>
            <div
              *ngIf="
                newPageForm.get('employeeInfoData.revenueCenters').errors?.['required'] &&
                newPageForm.get('employeeInfoData.revenueCenters').touched
              "
            >
              <h6 class="text-danger form-text">
                {{ 'Please select revenue centers.' | translate | async }}
              </h6>
            </div>
          </div>
        </div>



        <!-- Point of Sale PIN -->
        <div class="mb-3 row align-items-center">
          <label for="pin" class="col-sm-5 col-form-label">
            {{ 'Point of Sale PIN*' | translate | async }}
          </label>
          <div class="col-sm-7">
            <div class="input-group">
              <input
                type="number"
                class="form-control"
                id="pin"
                placeholder="{{'Enter 4 digit pin' | translate | async}}"
                formControlName="pin"
                maxlength="4"
                max = "9999"
                autocomplete="new-password"
                (focusout)="newPageForm.get('employeeInfoData.pin').markAsTouched()"
              />
              <!-- <button
                class="btn btn-outline-secondary"
                type="button"
                (click)="togglePIN()"
              >
                <i *ngIf="!NewPIN" class="fa fa-eye"></i>
                <i *ngIf="NewPIN" class="fa fa-eye-slash"></i>
              </button> -->
            </div>
            <div
            class="text-danger"
            *ngIf="
              newPageForm.get('employeeInfoData.pin').touched &&
              newPageForm.get('employeeInfoData.pin').invalid
            "
          >
            <div
              *ngIf="
                newPageForm.get('employeeInfoData.pin').errors?.['required'] &&
                !newPageForm.get('employeeInfoData.pin').hasError('pattern')
              "
            >
              <h6 class="text-danger form-text">{{ 'PIN is required.' | translate | async }}</h6>
            </div>
            <div
              *ngIf="
                newPageForm.get('employeeInfoData.pin').hasError('pattern')
              "
            >
              <h6 class="text-danger form-text">
                {{ 'PIN must be four digits.' | translate | async }}
              </h6>
            </div>
          </div>
          </div>
        </div>
      </div>

      <!-- Submit and Cancel Buttons -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click'); clearForm()">
          {{ 'Cancel' | translate | async }}
        </button>
        <button type="submit" class="btn btn-primary custom-btn" (click)="modal.dismiss('cancel click')"   [disabled]="this.newPageForm.invalid">
          {{ 'Save' | translate | async }}
        </button>
      </div>

    </form>
  </div>
</ng-template>
<!-- dropdown -->
<ng-template #showInviteEmployeeModal1 let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{'Invite a new employee' | translate | async}}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <form
      [formGroup]="newPageForm"
      (keydown.enter)="$event.preventDefault()"
      autocomplete="off"
    >
      <div formGroupName="storedata">
        <!-- Revenue Center -->
        <div class="mb-3 row align-items-center">
          <label for="revenueCenters" class="col-sm-5 col-form-label">
            {{ 'Select Store*' | translate | async }}
          </label>
          <div class="col-sm-7">
            <select class="form-control" id="storeid" formControlName="storeId">
              <option value="" disabled selected>Select Store</option>
              <option *ngFor="let store of storeOptions" [value]="store.value">
                {{ store.label }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Submit and Cancel Buttons -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click')" >
          {{ 'Cancel' | translate | async }}
        </button>
        <button (click)="openInviteEmployeePopup(); modal.dismiss('cancel click')" class="btn btn-primary custom-btn" [disabled]="!this.newPageForm.value.storedata.storeId">
          {{ 'Next' | translate | async }}
        </button>
      </div>

    </form>
  </div>
</ng-template>
<ng-template #loginOption let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{'Select employee to Login' | translate | async}}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <form
      [formGroup]="newPageForm"
      (keydown.enter)="$event.preventDefault()"
      autocomplete="off"
    >
      <div formGroupName="logindata">
        <!-- Revenue Center -->
        <div class="mb-3 row align-items-center">
          <label for="revenueCenters" class="col-sm-5 col-form-label">
            {{ 'Select Employee*' | translate | async }}
          </label>
          <div class="col-sm-7">
            <select class="form-control" id="mailId" formControlName="mailId">
              <option value="" disabled selected>Select Employee</option>
              <option *ngFor="let mail of mailOptions" [value]="mail.value">
                {{ mail.label }} ({{mail.value}})
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Submit and Cancel Buttons -->
      <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click'); logindataClear();" >
          {{ 'Cancel' | translate | async }}
        </button>
        <button (click)="Logout(); modal.dismiss('cancel click')" class="btn btn-primary custom-btn" [disabled]="!this.newPageForm.value.logindata.mailId">
          {{ 'Login' | translate | async }}
        </button>
      </div>

    </form>
  </div>
</ng-template>
<ng-template #licencerenewpop let-modal>
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1 class="color-212121 f-24 fw-700 text-start activecode">Activation Code</h1>
      <img
        src="assets/images/closeIcon.svg"
        class="close-icon"
        (click)="modal.dismiss('cancel click')"
      />
    </div>
    <form [formGroup]="ActiveCodeForm" (ngSubmit)="activate()">
      <div class="mb-3">
        <label for="activationCode" class="activation-label color-212121 text-start f-18 fw-700 mb-4">Enter Activation Code</label>
        <input id="activationCode" type="text" class="form-control activation-input" placeholder="000000 - 000000 - 000000 - 000000" aria-label="Enter Activation Code"
          #activationCodeInput formControlName="ActiveCode"  (keydown)="preventSpace($event)" (input)="removeSpaces($event)" maxlength="28" pattern="[^ ]*"  required />
      </div>
      <button class="btn activate-button f-18 fw-700 mb-3" type="submit" [disabled]="ActiveCodeForm.get('ActiveCode')?.value.length < 24">Activate</button>
         <!-- <div class="purchase-link text-center">
        <span class="f-14 fw-500 color-212121">No Activation Code?</span>
        <a href="https://www.eatos.com/pricing/" target="_blank" class="f-14 fw-600 color-primary ms-1">Purchase</a>
      </div> -->
    </form>
  </div>
</ng-template>
<ng-template #logout role="document" let-modal>
  <div class="modal-body border-0 text-center">
    <div class="delete-icon-info">
      <div class="delete-icon-info-img">
        <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex; animation: none !important">
          <div class="swal2-icon-content">!</div>
        </div>

        <h2 class="swal2-title swal2-title-main" id="swal2-title-main" style="display: flex; justify-content: center;">
          {{ "Are you sure you want to log in to the" | translate | async }} {{"Selected Employee account?" | translate | async }}
          <!-- {{ "Are you sure you want to log in to the" | translate | async }} {{ merchantName }}{{" account?" | translate | async }} -->
        </h2>

        <h2 class="swal2-title swal2-title-sub" id="swal2-title-sub" style="display: flex; justify-content: center; font-size: 0.9em;">
          {{ "Clicking Yes will log you out of the current admin session." | translate | async }}
        </h2>
      </div>
    </div>
  </div>

  <div class="modal-footer border-0">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 text-center">
          <button class="btn add-btn-one fw-bold mt-2 cust-btn" (click)="login()">
            {{ "Yes" | translate | async }}
          </button>
          <button class="btn btn-dark add-btn-two fw-bold mt-2" style="margin-left: 15px" (click)="modal.dismiss('cancel click'); logindataClear()">
            {{ "Cancel" | translate | async }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #paymentIntegrationModal let-modal>
  <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; padding-bottom: 8px; border-bottom: none;">
    <h5 class="modal-title">
      {{ 'Add payment Integration' | translate | async }} - {{ integrationdetails.name }}
    </h5>
    <!-- <h5 class="modal-title">
      {{ 'Payment Integration' | translate | async }} - {{ integrationdetails.name }}
    </h5> -->
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); clearIntegrationForm()" style="background: transparent; border: none; font-size: 40px;">&times;</button>
  </div>
  <div class="modal-body" style="padding: 20px;">
    <form
      [formGroup]="paymentIntegrationForm"
      (keydown.enter)="$event.preventDefault()"
      autocomplete="off"
    >
      <!-- <div formGroupName="storedata"> -->
        <!-- Revenue Center -->
        <div class="mb-3 row align-items-center" style="margin-bottom: 16px;" *ngIf="integrationdetails.name !== 'Adyen'">
          <label for="revenueCenters" class="col-sm-3 p-0 col-form-label" style="font-weight: 500;">
            {{ 'Select Store*' | translate | async }}
          </label>
          <div class="col-sm-9 p-0">
            <ng-select
              [items]="storeOptions"
              bindLabel="label"
              bindValue="value"
              [multiple]="true"
              placeholder="Select Store"
              formControlName="storeIdInt"
              [closeOnSelect]="true"
              [clearable]="false"
              style="width: 100%;">
              <ng-template ng-header-tmp>
                <div *ngIf="storeOptions.length > 5" class="select-buttons" style="display: flex; gap: 8px; padding: 8px;">
                    <button type="button" (click)="selectAll()" class="select-button" style="padding: 4px 8px; background: black; color: white; border: none; border-radius: 4px;">Select All</button>
                    <button type="button" (click)="deselectAll()" class="select-button" style="padding: 4px 8px; background: #000000; color: white; border: none; border-radius: 4px;">Deselect All</button>
                </div>
              </ng-template>
              <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                <div *ngIf="items.length > 0">
                  <span *ngFor="let item of items.slice(0, 2); let i = index">
                    {{ item.label }}<span *ngIf="i < items.length - 1 && i < 1">, </span>
                  </span>
                  <span *ngIf="items.length > 2">
                    and {{ items.length - 2 }} more
                  </span>
                </div>
                <div *ngIf="items.length === 0">
                  {{ placeholder }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      <!-- </div> -->

      <!-- Add Toggle Button for Default Payment -->
      <div class="mb-3 row align-items-center" style="margin-bottom: 16px;">
        <label for="defaultPayment" class="col-sm-3 p-0 col-form-label" style="font-weight: 500;">
          {{ 'Default Payment' | translate | async }}
        </label>
        <div class="col-sm-9 p-0">
          <label class="switch" style="margin: 0; border: none">
            <div class="form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                formControlName="defaultPayment"
              />
            </div>
          </label>
        </div>
      </div>

      <!-- Add Dropdown for Enabling App Options -->
      <div class="mb-3 row align-items-center" style="margin-bottom: 16px;" *ngIf="integrationdetails.name !== 'Adyen'">
        <label for="enableAppOptions" class="col-sm-3 p-0 col-form-label" style="font-weight: 500;">
          {{ 'Enable App Options*' | translate | async }}
        </label>
        <div class="col-sm-9 p-0">
          <ng-select
            [items]="appOptions"
            bindLabel="label"
            bindValue="value"
            [multiple]="true"
            placeholder="{{ 'Select Application' | translate | async }}"
            formControlName="enableAppOptions"
            [closeOnSelect]="true"
            [clearable]="false"
            >
            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div *ngIf="items.length > 0">
                <span *ngFor="let item of items.slice(0, 2); let i = index">
                  {{ item.label }}<span *ngIf="i < items.length - 1 && i < 1">, </span>
                </span>
                <span *ngIf="items.length > 2">
                  and {{ items.length - 2 }} more
                </span>
              </div>
              <div *ngIf="items.length === 0">
                {{ 'Select Application' | translate | async }}
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="mb-3 row align-items-center" style="margin-bottom: 16px;" *ngIf="integrationdetails.name == 'Adyen'">
        <label for="enableAppOptions" class="col-sm-3 p-0 col-form-label" style="font-weight: 500;">
          {{ 'Select Split Rule*' | translate | async }}
        </label>
        <div class="col-sm-9 p-0">
          <ng-select
            placeholder="{{ 'Select Rule' | translate | async }}"
            formControlName="splitConfigurationId"
            [clearable]="false"
          >
            <ng-option value="">
              {{ "Select Rule" | translate | async }}
            </ng-option>
             <ng-option
              *ngFor="let rule of splitRules"
              [value]="rule.value"
            >
              {{ rule.label | translate | async }}
            </ng-option>
          </ng-select>
        </div>
      </div>
      <!-- card connect start -->
      <div *ngIf="this.cardconnectshow">
        <!-- Username -->
        <div class="mb-3 row align-items-center" style="margin-bottom: 16px;">
          <label for="username" class="col-sm-3 p-0 col-form-label" style="font-weight: 500;">
            <span *ngIf="integrationdetails.value === 'CARDCONNECT'">{{ 'Username*' | translate | async }}</span>
            <span *ngIf="integrationdetails.value === 'TOTALPAY'">{{ 'Merchant Key*' | translate | async }}</span>
          </label>
          <div class="col-sm-9 p-0">
            <input type="text" class="form-control" formControlName="username" />
          </div>
        </div>

      <!-- Password -->
      <div class="mb-3 row align-items-center" style="margin-bottom: 16px;">
        <label for="password" class="col-sm-3 p-0 col-form-label" style="font-weight: 500;">
          {{ 'Password*' | translate | async }}
        </label>
        <div class="col-sm-9 p-0">
          <input type="password" class="form-control" formControlName="password" />
        </div>
      </div>

      <!-- Merchant ID -->
      <div *ngIf="integrationdetails.value === 'CARDCONNECT'" class="mb-3 row align-items-center" style="margin-bottom: 16px;">
        <label for="merchantId" class="col-sm-3 p-0 col-form-label" style="font-weight: 500;">
          {{ 'Merchant ID*' | translate | async }}
        </label>
        <div class="col-sm-9 p-0">
          <input type="text" class="form-control" formControlName="merchantId" />
        </div>
      </div>
      </div>
      <!-- card connect End -->
       <!-- loyaltyOS start -->
       <div *ngIf="this.loyaltyosshow">
        <div class="mb-3 row align-items-center" style="margin-bottom: 16px;">
        <label for="Enablemultipleearnings" class="col-sm-3 p-0 col-form-label" style="font-weight: 500;">
          {{ 'Enable multiple earnings' | translate | async }}
        </label>
        <div class="col-sm-9 p-0">
          <label class="switch" style="margin: 0; border: none">
            <div class="form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                formControlName="Enablemultipleearnings"
              />
            </div>
          </label>
        </div>
      </div>
    </div>
      <!-- LoyaltyOs Ends -->
      <!-- Submit and Cancel Buttons -->
      <div class="modal-footer" style="border-top: none; padding-top: 8px; display: flex; justify-content: flex-end;">
        <!-- <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click')" style="background-color: #6c757d; color: white; border: none; padding: 8px 16px; border-radius: 4px; margin-right: 8px;">
          {{ 'Cancel' | translate | async }}
        </button> -->
        <button type="submit" class="btn custom-btn" (click)="onPaymentIntegrationSubmit()" [disabled]="this.paymentIntegrationForm.invalid" style="background-color: black; color: white; border: none; padding: 8px 16px; border-radius: 4px;">
          {{ 'Save' | translate | async }}
        </button>
      </div>

    </form>
  </div>
</ng-template>
<div class="container-fluid merchants-details-main p-0 merchant-margin" id="merchants-details-page" *ngIf="selectedTab === 1">
<ng-container *ngIf="loadData">
  <div class="merchants-users-details">
    <div class="w-full d-flex align-items-center gap-3 merchant-main">
        <div class=" merchants-users all-width-50 user-width">
            <div class="w-full d-flex align-items-center gap-3 merchant-width">
                <div class="all-width-50 users-details users-detail-all d-flex align-items-center gap-2 user-width ">
                  <div class="Sales-UB d-flex align-items-center justify-content-center f-32 fw-600">{{ getMerchantInitials() }}</div>
                    <h1 class="f-14 fw-600 user-name-details mb-3 mt-3">{{ merchantName | translate | async}}</h1>
                    <p class="f-12 fw-500 user-name-details  mb-2">{{ merchantType | translate | async}}</p>
                    <div class="d-flex align-items-center justify-content-between" style="width: max-content;">
                      <p class="f-12 fw-500 user-name-details" style="margin-right: 7px;">{{'Merchant ID'  | translate | async}}</p>
                      <p class="f-12 fw-500 user-name-details">{{ merchantId }}</p>
                  </div>
                    <!-- <p class="f-12 fw-500 user-name-details mb-0" title="MerchantId">{{ merchantId }}</p> -->
                    <p class="f-12 fw-500 user-name-details mb-0" *ngIf="merchantEmailAccount; else noEmail">
                      {{ merchantEmailAccount }}
                    </p>
                    <ng-template #noEmail>
                      <p class="f-12 fw-500 user-name-details mb-0">No email available</p>
                    </ng-template>
                    <div class="d-flex gap-3 justify-content-center align-items-center mt-3">
                        <button class="vip-btn"><img src="assets\images\merchants-img\Star.png" alt=""
                                class="me-1"><span class="f-12 fw-500 vip-details ps-2">{{'VIP'| translate | async}}</span></button>
                        <button class="Hours-btn"><img src="assets\images\merchants-img\TimeCircle.svg" alt=""><span
                                class="f-12 fw-500 Hours-details ps-2">24 {{'Hours' | translate | async}}</span></button>
                    </div>
                    <div  *ngIf="hasAccess('Merchants', 2)" >
                    <button class="Bandwidth-btn mt-3"
                    accessControl module="Merchants" access="4"
                    (click)="LoginPopup()">
                    <!-- (click)="Logout()"> -->
                        <span
                            class="f-12 fw-500 Bandwidth-details ps-2">{{'Login'| translate | async}}
                          </span>
                   </button>
                  </div>

                </div>
                <div class="all-width-50 Hardware-details">
                    <div class="d-flex gap-3 Subscription-sub">
                        <div class="all-width-50 users-details merchants-users p-3 height-users">
                            <div class=" users-detail-all ">
                                <div
                                    class="phone-img merchants-users d-flex justify-content-center align-items-center mb-3">
                                    <img src="assets\images\merchants-img\Hardware.svg" alt="">
                                </div>
                                <h1 class="f-16 fw-600 user-name-details  text-start  mb-3">{{'Hardware' | translate | async}}</h1>
                                <p class="f-14 fw-400 user-name-details mb-0 text-start">{{'Subscription' | translate | async}}</p>
                            </div>
                        </div>
                        <div class="all-width-50 users-details merchants-users p-3 height-users">
                            <div class=" users-detail-all  ">
                                <div
                                    class="phone-img merchants-users d-flex justify-content-center align-items-center mb-3">
                                    <img src="assets\images\merchants-img\phone.svg" alt="">
                                </div>
                                <h1 class="f-16 fw-600 user-name-details text-start mb-3 ">{{'Sunmi'| translate | async}}</h1>
                                <p class="f-14 fw-400 user-name-details mb-0 text-start">{{'Device Type' | translate | async}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="Hadware-details mt-3">

                        <div
                            class="d-flex align-items-center justify-content-between user-detail-info pb-3 Owner-info">
                            <div class="d-flex align-items-center gap-2">
                                <img src="assets\images\merchants-img\Location.png" alt="">
                                <p class="f-14 fw-500 user-name mb-0 user-name">{{'Locations' | translate | async}}</p>

                            </div>
                            <p class="f-14 fw-600 user-name-details mb-0">{{ totalLocations }}</p>
                        </div>
                        <div
                            class="d-flex align-items-center justify-content-between user-detail-info py-3 Owner-info">
                            <div class="d-flex align-items-center gap-2">
                                <img src="assets\images\merchants-img\moniter.svg" alt="">
                            <p class="f-14 fw-500 user-name mb-0 user-name">{{'Devices' | translate | async}}</p></div>
                            <p class="f-14 fw-600 user-name-details mb-0">{{ totalHardware }}</p>
                        </div>
                        <div class="d-flex align-items-center justify-content-between user-detail-info pt-3">
                          <div class="d-flex align-items-center gap-2">
                            <img src="assets/images/merchants-img/worker.svg" alt="">
                            <p class="f-14 fw-500 user-name mb-0 user-name">{{'Employees' | translate | async}}</p>
                          </div>
                          <div class="d-flex align-items-center gap-2">
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-user-plus"
                            (click)="openInviteEmployeePopup1()"
                          >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="8.5" cy="7" r="4"></circle>
                            <line x1="20" y1="8" x2="20" y2="14"></line>
                            <line x1="23" y1="11" x2="17" y2="11"></line>
                          </svg>
                            <p class="f-14 fw-600 user-name-details mb-0">{{ totalEmployeesCount }}</p>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="merchants-users all-width-50 user-width">
            <div class="w-full merchant-flex d-flex align-items-center gap-3">
                <div class=" Owner-details all-width-50 owner-padd-sub">
                    <div class="Owner-info d-flex gap-3 align-items-center pb-2">
                        <img src="assets/images/merchants-img/user.svg" alt="">
                        <p class="f-14 fw-500 mb-0">
                            {{'Owner Information' | translate | async}}
                        </p>
                    </div>
                    <div class="">
                        <div class="d-flex align-items-center justify-content-between user-detail-info">
                            <p class="f-14 fw-500 user-name mb-0">{{'Name' | translate | async}}</p>
                            <p *ngIf="ownerEmployeeDetails?.employeeFirstName || ownerEmployeeDetails?.employeeLastName; else noDetails" class="f-14 fw-600 user-name-details mb-0">
                              {{ (ownerEmployeeDetails?.employeeFirstName || '') + ' ' + (ownerEmployeeDetails?.employeeLastName || '') | translate | async }}
                            </p>
                            <ng-template #noDetails>
                              <p class="f-14 fw-600 user-name-details mb-0">{{ 'No Name available' | translate | async }}</p>
                            </ng-template>
                        </div>
                        <div class="d-flex align-items-center justify-content-between user-detail-info">
                            <p class="f-14 fw-500 user-name mb-0">{{'Mobile' | translate | async}}</p>
                            <p *ngIf="ownerEmployeeDetails?.employeeMobile; else noMobile" class="f-14 fw-600 user-name-details mb-0">
                              {{ ownerEmployeeDetails.employeeMobile | translate | async }}
                            </p>
                            <ng-template #noMobile>
                              <p class="f-14 fw-600 user-name-details mb-0">{{ 'No Mobile available' | translate | async }}</p>
                            </ng-template>
                        </div>
                        <div class="d-flex align-items-center justify-content-between user-detail-info">
                            <p class="f-14 fw-500 user-name mb-0">{{'Email' | translate | async}}</p>
                            <p *ngIf="ownerEmployeeDetails?.employeeEmail; else noOwnerEmail" class="f-14 fw-600 user-name-details mb-0">
                              {{ ownerEmployeeDetails.employeeEmail | translate | async }}
                            </p>
                            <ng-template #noOwnerEmail>
                              <p class="f-14 fw-600 user-name-details mb-0">{{ 'No Email available' | translate | async }}</p>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div class=" Owner-details all-width-50 owner-padd-sub manager-width">
                    <div class="Owner-info d-flex gap-3 align-items-center pb-2">
                        <img src="assets/images/merchants-img/Manager.svg" alt="">
                        <p class="f-14 fw-500 mb-0">
                            {{'Manager Information' | translate | async}}
                        </p>
                    </div>
                    <div class="">
                        <div class="d-flex align-items-center justify-content-between user-detail-info">
                            <p class="f-14 fw-500 user-name mb-0">{{'Name' | translate | async}}</p>
                            <p *ngIf="managerEmployeeDetails?.employeeFirstName || managerEmployeeDetails?.employeeLastName; else noManagerDetails" class="f-14 fw-600 user-name-details mb-0">
                              {{ (managerEmployeeDetails?.employeeFirstName || '') + ' ' + (managerEmployeeDetails?.employeeLastName || '') | translate | async }}
                            </p>
                            <ng-template #noManagerDetails>
                              <p class="f-14 fw-600 user-name-details mb-0">{{ 'No Name available' | translate | async }}</p>
                            </ng-template>
                        </div>
                        <div class="d-flex align-items-center justify-content-between user-detail-info">
                            <p class="f-14 fw-500 user-name mb-0">{{'Mobile' | translate | async}}</p>
                            <p *ngIf="managerEmployeeDetails?.employeeMobile; else noManagerMobile" class="f-14 fw-600 user-name-details mb-0">
                              {{ managerEmployeeDetails.employeeMobile | translate | async }}
                            </p>
                            <ng-template #noManagerMobile>
                              <p class="f-14 fw-600 user-name-details mb-0">{{ 'No Mobile available' | translate | async }}</p>
                            </ng-template>
                        </div>
                        <div class="d-flex align-items-center justify-content-between user-detail-info">
                            <p class="f-14 fw-500 user-name mb-0">{{'Email' | translate | async}}</p>
                            <p *ngIf="managerEmployeeDetails?.employeeEmail; else noManagerEmail" class="f-14 fw-600 user-name-details mb-0">
                              {{ managerEmployeeDetails.employeeEmail | translate | async }}
                            </p>
                            <ng-template #noManagerEmail>
                              <p class="f-14 fw-600 user-name-details mb-0">{{ 'No Email available' | translate | async }}</p>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full merchant-flex d-flex align-items-center gap-3 mt-3">
                <div class="Owner-details all-width-50">


                    <div class="d-flex align-items-center justify-content-between user-detail-info mt-0">
                        <p class="f-14 fw-500 user-name mb-0">{{'License Key' | translate | async}}</p>
                        <div class="d-flex align-items-center hap-2 user-name-details mb-0">
                          <div class="f-14 fw-600 me-2" *ngIf="getMaskedLicenseKey(); else noLicenseKey">
                            {{ getMaskedLicenseKey() }}
                          </div>
                          <ng-template #noLicenseKey>
                            <div class="f-14 fw-600 me-2 license-detrails-main">No license key available</div>
                          </ng-template>
                          <img src="assets/images/merchants-img/Show.svg" alt="Show/Hide License Key" (click)="toggleLicenseKeyVisibility()">
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between user-detail-info pt-3"
                        style="border-top: 1px solid #D6D6D6;">
                        <p class="f-14 fw-500 user-name mb-0">{{'Activated On' | translate | async}}</p>
                        <p class="f-14 fw-600 user-name-details mb-0" *ngIf="subscriptionDetails?.createdAt; else noDate">
                          {{ _convertDate(subscriptionDetails?.createdAt) }}
                        </p>
                        <ng-template #noDate>
                          <p class="f-14 fw-600 user-name-details mb-0">NA</p>
                        </ng-template>
                    </div>
                    <div class="d-flex align-items-center justify-content-between user-detail-info pt-3"
                    style="border-top: 1px solid #D6D6D6;">
                 <p class="f-14 fw-500 user-name mb-0">{{'Expiry' | translate | async}}</p>

                 <p class="f-14 fw-600 user-name-details mb-0">
                  <ng-container *ngIf="isPastExpirationDate()">
                    <!-- Add your SVG here with a tooltip -->
                    <button class="update-license-btn overflow-detrails-main" *ngIf="hasAccess('Merchants', 2)" accessControl module="Merchants" access="3" (click)="Licencerenew()">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" title="Renew License">
                        <path d="M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8C14.5 11.59 11.59 14.5 8 14.5ZM7 4H9V9H7V4ZM7 11H9V13H7V11Z" fill="#000"/>
                      </svg>
                      Update License
                    </button>
                  </ng-container>
                  {{ getFormattedExpirationDate() }}

                </p>
                <ng-template #noExpirationDate>
                  <p class="f-14 fw-600 user-name-details mb-0">NA</p>
                </ng-template>
                 <ng-template #noExpirationDate>
                   <p class="f-14 fw-600 user-name-details mb-0">NA</p>
                 </ng-template>

                </div>

                </div>
                <!-- <div class="Owner-details all-width-50 owner-pad-sub owner-pad-sub" style="padding: 20px;">
                  <div class="user-detail-info m-0">
                    <p class="f-14 fw-500  Owner-info mb-0">{{ 'Card-connect PCI Audit' | translate | async }}</p>
                  </div>
                  <form [formGroup]="auditForm" class="align-items-center justify-content-between gap-2 mt-3 changedirsalesperson">

                    <div class="d-flex justify-content-between">
                      <div>
                        <p class="f-14 fw-500 user-name mb-0">{{ 'PCI Audit' | translate | async }}</p>
                      </div>
                      <div class="mt-sm-0">
                        <div class="form-switch">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            formControlName="pciAudit"
                            (change)="updatePciaudit($event)"
                          />
                        </div>
                      </div>
                    </div>
                    <div style="border-top: 1px solid #D6D6D6;">
                      <p class="f-14 fw-500 user-name mb-1 mt-1">{{ 'PCI Expiration Date :' | translate | async }}</p>
                      <input
                        style=" height: 33px;"
                        type="date"
                        class="form-control"
                        id="pciExpireDate"
                        formControlName="pciExpireDate"
                        (change)="updatePciaudit($event)"
                      />
                    </div>
                  </form>
                </div> -->
                <div class="Owner-details all-width-50 owner-pad-sub owner-pad-sub" style="padding: 20px;">
                  <div class="user-detail-info m-0">
                    <p class="f-14 fw-500 user-name Owner-info mb-0 py-4">{{'Sales Person' | translate | async}}</p>
                  </div>
                  <div class="d-flex align-items-center justify-content-between gap-2 mt-3 changedirsalesperson">
                    <div class="Sales-manager d-flex align-items-center justify-content-center f-16 fw-600">
                      <ng-container *ngIf="merchantSalesPerson; else showSalesUserImage">
                        {{ getSalesPersonInitials() }}
                      </ng-container>
                      <ng-template #showSalesUserImage>
                        <img
                        class="hover-shadow"
                        style="background-color: #FFFFFF;"
                        src="../../../../assets//images/topbar-icons/user.svg"
                        alt=""
                        height="50"
                        width="50"
                        />
                      </ng-template>
                    </div>
                    <div class="">
                      <input *ngIf="showInput" type="text" [(ngModel)]="merchantSalesPerson" class="form-control" placeholder="Enter Sales Person">

                    </div>
                    <div *ngIf="hasAccess('Merchants', 2)">
                      <button class="save-btn m-0" (click)="updateSalesPerson()">
                        {{ merchantSalesPerson ? 'Update' : 'Add' }}
                      </button>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full d-flex align-items-center gap-3 owner-sub-main">

        <!-- <div class=" merchants-users">
            <div class="title-name-details d-flex align-items-center justify-content-between gap-2 mt-3">

              <div class="pad-right
                bor-right">
                    <div>
                        <img src="assets\images\merchants-img\eatOS.svg" alt="">
                    </div>
                    <h1 class="f-16 fw-600 user-name-details mt-4 mb-4">{{'eatOS' | translate | async}}</h1>
                    <p class="f-14 fw-500 user-name">{{'Active' | translate | async}} : <span class="f-20 fw-600 user-name-details">{{ eatOSActiveStores }}</span>
                    </p>
                    <p class="f-14 fw-500 user-name mb-0">{{'Total' | translate | async}} : {{ eatOSActiveStores }}</p>
                </div>
                <div class="pad-right
                bor-right">
                    <div>
                        <img src="assets\images\merchants-img\retailOS.svg" alt="">
                    </div>
                    <h1 class="f-16 fw-600 user-name-details mt-4 mb-4">{{'retailOS' | translate | async}}</h1>
                    <p class="f-14 fw-500 user-name">{{'Active' | translate | async}} : <span class="f-20 fw-600 user-name-details">{{ retailsOSActiveStores }}</span>
                    </p>
                    <p class="f-14 fw-500 user-name mb-0">{{'Total' | translate | async}} : {{ retailsOSActiveStores }}</p>
                </div>
                <div class="pad-right
               bor-right">
                    <div>
                        <img src="assets\images\merchants-img\berweryOS.svg" alt="">
                    </div>
                    <h1 class="f-16 fw-600 user-name-details mt-4 mb-4">{{'breweryOS' | translate | async}}</h1>
                    <p class="f-14 fw-500 user-name">{{'Active' | translate | async}} : <span class="f-20 fw-600 user-name-details">{{ breweryOSActiveStores }}</span>
                    </p>
                    <p class="f-14 fw-500 user-name mb-0">{{'Total' | translate | async}} : {{ breweryOSActiveStores }}</p>
                </div>
                <div class="pad-right
                ">
                    <div>
                        <img src="assets\images\merchants-img\barOS.svg" alt="">
                    </div>
                    <h1 class="f-16 fw-600 user-name-details mt-4 mb-4">{{'barOS' | translate | async}}</h1>
                    <p class="f-14 fw-500 user-name">{{'Active' | translate | async}} : <span class="f-20 fw-600 user-name-details">{{ barOSActiveStores }}</span>
                    </p>
                    <p class="f-14 fw-500 user-name mb-0">{{'Total' | translate | async}} : {{ barOSActiveStores }}</p>
                </div>

            </div>
        </div> -->
        <div class=" Owner-details-main owner-width" >
              <div style="display: flex; flex-direction: column; align-items: flex-start;">
                <div class="Hadware-details mt-3 Hardware-width" style="width: -webkit-fill-available;">
                  <div *ngIf="!isPastExpirationDate()" class="d-flex justify-content-end align-items-center edit-icon">
                    <!-- <button class="tooltip-custom"> -->
                      <i triggers="mouseenter:mouseleave"
                    [ngbPopover]="'Edit'"
                    placement="top">
                    <img
                    style="cursor: pointer;"
                      src="/assets/images/Edit.svg"
                      alt="edit"
                      (click)="openEditLicenseModal()"
                    />
                    </i>

                      <!-- <div class="cust-tool">Edit</div> -->
                    <!-- </button> -->
                  </div>
                  <div class="table-responsive">
                    <table class="table mb-0">
                        <thead>
                            <tr class="user-detail-info py-3 Owner-info">
                                <th class="d-flex align-items-center gap-2">
                                    <p class="f-14 fw-500 user-name mb-0">{{'Product' | translate | async}}</p>
                                </th>
                                <th class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{'Limit' | translate | async}}</p>
                                </th>
                                <th class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{'Usage' | translate | async}}</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="user-detail-info py-3 Owner-info">
                                <td>
                                    <div class="d-flex align-items-center gap-2">
                                        <img src="assets/images/merchants-img/worker.svg" alt="">
                                        <p class="f-14 fw-500 user-name mb-0">{{'Employee' | translate | async}}</p>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.employeeLimit }}</p>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.employeeCount }}</p>
                                </td>
                            </tr>
                            <tr class="user-detail-info py-3 Owner-info">
                                <td>
                                    <div class="d-flex align-items-center gap-2">
                                        <img src="assets/images/merchants-img/moniter.svg" alt="">
                                        <p class="f-14 fw-500 user-name mb-0">{{'Account' | translate | async}}</p>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.accountLimit }}</p>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.accountCount }}</p>
                                </td>
                            </tr>
                            <tr class="user-detail-info py-3 Owner-info">
                                <td>
                                    <div class="d-flex align-items-center gap-2">
                                        <img src="assets/images/merchants-img/moniter.svg" alt="">
                                        <p class="f-14 fw-500 user-name mb-0">{{'QSR' | translate | async}}</p>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.qsrLimit }}</p>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.qsrCount }}</p>
                                </td>
                            </tr>
                            <tr class="user-detail-info py-3 Owner-info">
                                <td>
                                    <div class="d-flex align-items-center gap-2">
                                        <img src="assets/images/merchants-img/moniter.svg" alt="">
                                        <p class="f-14 fw-500 user-name mb-0">{{'KDS' | translate | async}}</p>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.kdsLimit }}</p>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.kdsCount }}</p>
                                </td>
                            </tr>
                            <tr class="user-detail-info py-3 Owner-info">
                                <td>
                                    <div class="d-flex align-items-center gap-2">
                                        <img src="assets/images/merchants-img/moniter.svg" alt="">
                                        <p class="f-14 fw-500 user-name mb-0">{{'Kiosk' | translate | async}}</p>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.kioskLimit }}</p>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.kioskCount }}</p>
                                </td>
                            </tr>
                            <tr class="user-detail-info py-3 Owner-info">
                                <td>
                                    <div class="d-flex align-items-center gap-2">
                                        <img src="assets/images/merchants-img/moniter.svg" alt="">
                                        <p class="f-14 fw-500 user-name mb-0">{{'Full' | translate | async}}</p>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.fullLimit }}</p>
                                </td>
                                <td class="text-center">
                                    <p class="f-14 fw-600 user-name-details mb-0">{{ subscriptionDetails2?.fullCount }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                  </div>
              </div>
      </div>


        <div class=" Owner-details-main owner-width">
        <div style="display: flex; flex-direction: column; align-items: flex-start;">
          <div class="Hadware-details mt-3 Hardware-width" style="width: -webkit-fill-available;">

            <div class="Owner-details  owner-pad-sub owner-pad-sub" style="margin-top: 42px;">
              <div class="user-detail-info m-0" style="display: flex; justify-content: center;">
                <p class="f-14 fw-500  Owner-info mb-2">{{ 'Card-connect PCI Audit' | translate | async }}</p>
              </div>
              <form [formGroup]="auditForm" class="align-items-center justify-content-between gap-2 mt-3 changedirsalesperson">

                <div class="d-flex justify-content-between" style="width: 260px">
                  <div>
                    <p class="f-14 fw-500 user-name mb-2">{{ 'PCI Audit' | translate | async }}</p>
                  </div>
                  <div class="mt-sm-0">
                    <div class="form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        formControlName="pciAudit"
                        (change)="updatePciaudit($event)"
                      />
                    </div>
                  </div>
                </div>
                <div style="border-top: 1px solid #D6D6D6;">
                  <div style="display: flex; justify-content: space-between; align-items: center" class="mt-2">
                    <span class="f-14 fw-500 user-name mb-1 ">{{ 'PCI Expiration Date :' | translate | async }}</span>
                    <span class="mb-1">{{getFormattedpciExpireDate()}}</span>
                </div>
                <div >
                  <input
                    *ngIf="showDateInput"
                    type="date"
                    class="form-control"
                    id="pciExpireDate"
                    formControlName="pciExpireDate"
                    (change)="updatePciaudit('date')"
                  />
                  <div *ngIf="hasAccess('Merchants', 2)">
                  <button *ngIf="!showDateInput" class="save-btn2 mt-3" style="padding-left: 0px;" (click)="showDateInputUi()">
                    {{ isPciExpireDateFormatted ? 'Edit' : 'Add' }}
                  </button>
                </div>
                </div>
              </div>
              </form>
            </div>

          </div>
        </div>
        </div>

        <div class=" Owner-details-main" style="width: -webkit-fill-available;">
            <div class="title-name-details mt-3">
                <div style="display: flex; flex-direction: column; align-items: flex-start;">
                    <h1 class="f-14 fw-500 color-2A">{{'Net Sales' | translate | async}}</h1>
                    <div class="chart-theme">
                      <div id="chart">
                        <ng-container *ngIf="!loader">
                          <apx-chart
                            class="apex-charts"
                            dir="ltr"
                            [series]="netSalesData.series"
                            [chart]="netSalesData.chart"
                            [tooltip]="netSalesData.tooltip"
                            [yaxis]="netSalesData.yaxis"
                            [legend]="netSalesData.legend"
                            [plotOptions]="netSalesData.plotOptions"
                            [grid]="netSalesData.grid"
                            [stroke]="netSalesData.stroke"
                            [xaxis]="netSalesData.xaxis"
                            [colors]="netSalesData.colors"
                            [fill]="netSalesData.fill"
                            [labels]="netSalesData.labels"
                            [markers]="netSalesData.markers"
                          >
                          </apx-chart>
                        </ng-container>
                        <ng-container *ngIf="loader" height="200px">
                          <div class="grapgh-loader">
                            <span class="loader1"></span>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="mt-3 location-main-part">
    <div class="">
        <h1 class="f-16 fw-600 user-name-details">{{'Locations' | translate | async}}</h1>
        <div class="">

            <div class="d-flex align-items-center gap-2 flex-wrap">
              <div *ngFor="let store of paginatedStoreDetails" class="California-details w-100 mt-3 califonornia-width">
                <div class="d-flex align-items-center gap-2">
                    <img src="assets\images\merchants-img\Location.png" alt="">
                    <!-- <h1 class="f-16 fw-600 user-name-details mb-0" *ngIf="store?.storeState; else noState">
                      {{ store.storeState | translate | async }}
                    </h1>
                    <ng-template #noState>
                      <h1 class="f-16 fw-600 user-name-details mb-0">No state available</h1>
                    </ng-template> -->
                    <h1 class="f-16 fw-600 user-name-details mb-0" *ngIf="store?.storeName; else noStore">
                      {{ store.storeName | translate | async }}
                    </h1>
                    <ng-template #noStore>
                      <h1 class="f-16 fw-600 user-name-details mb-0">No Store Name Available</h1>
                    </ng-template>
                </div>
                <div class="d-flex align-items-center justify-content-between gap-1 mt-4">
                  <p class="f-16 fw-500 user-name ">{{'Store ID'  | translate | async}}</p>
                  <p class="f-12 fw-400 user-name-details">{{store?.settings[0]?.storeId}}</p>
              </div>
                <div class="d-flex align-items-center justify-content-between gap-1 ">
                  <p class="f-16 fw-500 user-name ">{{'Open Time'  | translate | async}}</p>
                  <p class="f-16 fw-500 user-name-details">10:30 AM</p>
              </div>
              <div class="d-flex align-items-center justify-content-between gap-1">
                <p class="f-16 fw-500 user-name ">{{'Close Time' | translate | async}}</p>
                <p class="f-16 fw-500 user-name-details">11:00 PM</p>
              </div>
                <div class="d-flex align-items-center justify-content-between gap-1">
                    <p class="f-16 fw-500 user-name ">{{'Devices' | translate | async}}</p>
                    <p class="f-16 fw-500 user-name-details">{{ getDeviceCount(store.deviceDetails.summary) }}</p>
                </div>
                <div class="d-flex align-items-center justify-content-between gap-1 emp-location">
                    <p class="f-16 fw-500 user-name mb-0">{{'Employees' | translate | async}}</p>
                    <p class="f-16 fw-500 user-name-details mb-0">08/10</p>
                </div>
                <p class="mb-0 f-14 fw-500 user-name mt-3 text-center">{{'View Details' | translate | async}}</p>
            </div>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-end align-items-center w-100 gap-3 mt-3">
      <button class="save-btn m-0" (click)="previousPage()" [disabled]="currentPage === 1">Previous</button>
      <button class="save-btn m-0" (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
    </div>
</div>
<div class="d-flex align-items-center gap-4 integrations-size">
  <div class="mt-3 Integrations-main-part">
    <h1 class="f-16 fw-600 user-name-details">{{'Integrations' | translate | async}}</h1>
    <div class="grid-container mt-3">
      <!-- If allStoresintegrations is empty -->
      <div *ngIf="allStoresintegrations.length === 0" class="no-integrations-message">
        <p>No integrations available.</p>
      </div>

      <!-- Loop through integrations and display them -->
      <div *ngFor="let details of displayedIntegrations" class="Integrations-part-new d-flex align-items-center gap-3 pad-16 height-part">
        <div class="gusto-logo">
          <img [src]="getIntegrationImage(details.name)" class="image_theme" alt="" />
        </div>
        <div class="content_detalis">
          <h1 class="mb-0 f-14 fw-600 user-name-details">{{ getIntegrationName(details.name) | translate | async }}</h1>
          <p class="mb-0 f-10 fw-400 color-3A">{{ getIntegrationText(details.name) | translate | async }}</p>
        </div>
      </div>

      <!-- Show the remaining count if there are more than 3 integrations -->
      <div *ngIf="hasMoreIntegrations()" class="Integrations-part d-flex align-items-center gap-3 pad-16 height-part">
        <div class="f-14 fw-600 user-name-details">
          +{{ remainingIntegrationsCount }}
        </div>
        <div>
          <p class="mb-0 f-14 fw-500 user-name-details Customer-view">
            +{{ remainingIntegrationsCount }} {{ 'View all Integrations' | translate | async }}
          </p>
        </div>
      </div>
    </div>
  </div>
    <div class="mt-3 Integrations-main-part">
        <h1 class="f-16 fw-600 user-name-details">{{'Head Office Info' | translate | async}}</h1>
        <div class="d-flex align-items-center gap-3 mt-3 headinfo">
            <div class="Integrations-part">
                <div class="d-flex align-items-center gap-2 justify-content-between Owner-info "
                    style="padding-bottom: 12px;"><label for="" class="f-14 fw-500 user-name mb-0">{{'Address' | translate | async}}</label>
                    <p class="f-14 fw-600 user-name-details mb-0 overflow-detrails-main">{{ merchantAddress1 | translate | async}}</p>
                </div>
                <div class="d-flex align-items-center gap-2 justify-content-between Owner-info "
                    style="padding: 12px 0;"><label for="" class="f-14 fw-500 user-name mb-0">{{'City' | translate | async}} </label>
                    <p class="f-14 fw-600 user-name-details mb-0 overflow-detrails-main">{{ merchantCity | translate | async}}</p>
                </div>
                <div class="d-flex align-items-center gap-2 justify-content-between Owner-info "
                    style="padding: 12px 0;"><label for="" class="f-14 fw-500 user-name mb-0">{{'State' | translate | async}}</label>
                    <p class="f-14 fw-600 user-name-details mb-0 overflow-detrails-main">{{ merchantState | translate | async}}</p>
                </div>
                <div class="d-flex align-items-center gap-2 justify-content-between " style="padding-top: 12px;">
                    <label for="" class="f-14 fw-500 user-name mb-0">{{'ZIP' | translate | async}}</label>
                    <p class="f-14 fw-600 user-name-details mb-0 overflow-detrails-main">{{ merchantZipCode }}</p>
                </div>
            </div>
            <div class="Integrations-part">
                <!-- <div class="d-flex align-items-center gap-2 justify-content-between Owner-info "
                    style="padding-bottom: 12px;"><label for="" class="f-14 fw-500 user-name mb-0">{{'Open Time' | translate | async}}</label>
                    <p class="f-14 fw-600 user-name-details mb-0">10:30 AM</p>
                </div>
                <div class="d-flex align-items-center gap-2 justify-content-between Owner-info "
                    style="padding: 12px 0;"><label for="" class="f-14 fw-500 user-name mb-0">{{'Close Time' | translate | async}} </label>
                    <p class="f-14 fw-600 user-name-details mb-0">11:00 PM</p>
                </div> -->
                <div class="d-flex align-items-center gap-2 justify-content-between Owner-info "
                    style="padding: 12px 0;"><label for="" class="f-14 fw-500 user-name mb-0">{{'Mobile' | translate | async}}</label>
                    <p class="f-14 fw-600 user-name-details mb-0 overflow-detrails-main" *ngIf="merchantDetails?.merchantMobile; else noMerchantMobile">
                      {{ merchantDetails.merchantMobile }}
                    </p>
                    <ng-template #noMerchantMobile>
                      <p class="f-14 fw-600 user-name-details mb-0 overflow-detrails-main">No Mobile available</p>
                    </ng-template>
                </div>
                <div class="d-flex align-items-center gap-2 justify-content-between " style="padding-top: 12px;">
                    <label for="" class="f-14 fw-500 user-name mb-0">{{'Email' | translate | async}}</label>
                    <p class="f-14 fw-600 user-name-details mb-0">{{ merchantEmailAccount }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <div class="Customer-part mb-5">
    <h1 class="f-16 fw-600 user-name-details">{{'Customer Service History' | translate | async}}</h1>
    <div class="Customer-part d-flex align-items-center justify-content-between gap-3">
        <div class="d-flex align-items-center gap-3">
            <div class="customer-service d-flex align-items-center justify-content-center">{{'AS' | translate | async}}</div>
            <div>
                <h1 class="f-16 fw-600 user-name-details mb-1">{{'Taxes are Not Reflecting in Bills' | translate | async}}</h1>
                <p class="f-14 fw-500 user-name mb-0">{{'Andrew Stephen Raised a Ticket for Lorem ipsum dolor sit amet
                    consectetur.' | translate | async}}</p>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between gap-5">
            <div class="f-16 fw-400 color-3A">{{'Date' | translate | async}} : <span class="f-16 fw-500 user-name-details">20 {{'Mar' | translate | async}} 2024</span>
            </div>
            <div class="Customer-view user-name-details f-16 fw-600">{{'View Details' | translate | async}}</div>
        </div>
    </div>
    <div class="Customer-part d-flex align-items-center justify-content-between gap-3">
        <div class="d-flex align-items-center gap-3">
            <div class="customer-service d-flex align-items-center justify-content-center">{{'VL' | translate | async}}</div>
            <div>
                <h1 class="f-16 fw-600 user-name-details mb-1"> {{'Billing Server Down at' | translate | async}} 08:00PM</h1>
                <p class="f-14 fw-500 user-name mb-0">{{'Vanse Louis Raised a Ticket for Lorem ipsum dolor sit amet
                    consectetur.' | translate | async}}</p>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between gap-5">
            <div class="f-16 fw-400 color-3A">{{'Date' | translate | async}} : <span class="f-16 fw-500 user-name-details">12 {{'Mar' | translate | async}} 2024</span>
            </div>
            <div class="Customer-view user-name-details f-16 fw-600">{{'View Details' | translate | async}}</div>
        </div>
    </div>
</div> -->
</ng-container>
</div>
<div class="container-fluid merchants-details-main p-0 merchant-margin" id="merchants-details-page" *ngIf="selectedTab === 2">
  <!-- Orders Component -->
  <app-orders-list
  [isSuperAdmin]="true"
  [isMerchantId]="merchantId"
  [isStartDate]="startDateDisplay"
  [isEndDate]="endDateDisplay"
  ></app-orders-list>
  <!-- Orders Component -->
</div>

<div class="container-fluid merchants-details-main p-0 mb-5" id="merchants-details-page" *ngIf="selectedTab === 3">
  <!-- Integration Component -->
  <div style="background-color: white;">
   <!-- <div class="store-selector">
    <label for="store-select">Select Store:</label>
    <select id="store-select" name="store" (change)="onStoreChange($event)">
      <option value="" disabled selected>Select a store</option>
      <option *ngFor="let store of stores" [value]="store._id">{{ store.storeName }}</option>
    </select>
  </div> -->
  <div class="container-fluid merchants-details-main p-0 mb-5" id="merchants-details-page" *ngIf="selectedTab === 3">
          <div class="store-selector mb-4">
        <label for="store-select" class="f-14 fw-500 user-name mb-2 d-block">Select Store:</label>
        <select id="store-select" class="form-control" [(ngModel)]="currentStore" (change)="onStoreChange($event)">
          <option value="" disabled>Select a store</option>
          <option *ngFor="let store of storeDetails" [value]="store._id">{{ store.storeName }}</option>
        </select>
      </div>
    <div class="integration-container">
      <!-- <div class="store-selector mb-4">
        <label for="store-select" class="f-14 fw-500 user-name mb-2 d-block">Select Store:</label>
        <select id="store-select" class="form-control" [(ngModel)]="currentStore" (change)="onStoreChange($event)">
          <option value="" disabled>Select a store</option>
          <option *ngFor="let store of storeDetails" [value]="store._id">{{ store.storeName }}</option>
        </select>
      </div> -->
      <div class="integration-item" style="cursor: pointer" *ngFor="let detail of filteredIntegrationDetails">
        <div class="integration-image">
          <img [src]="detail.img" alt="{{ detail.name }}">
        </div>
        <div class="integration-content" (click)="openPaymentIntegrationPopup(detail)" >
          <div class="integration-header">
            <div>
              <h3>{{ detail.name }}</h3>
              <p>{{ detail.p }}</p>
              <div class="integration-types">
                <span *ngFor="let type of detail.type">{{ type }}</span>
              </div>
            </div>
            <!-- <button class="custom-btninstalled" [class.installed]="detail.isIntegrated">
              {{ detail.isIntegrated ? 'App Installed' : 'Install App' }}
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <!-- Integration Component -->
</div>
<!-- <div *ngIf="isDivVisible">
  <div class="Urban-California-main">
      <div class="card f-14">
          <div class="card-body">
              <h1 class="f-20 fw-600 Urban-title color-000">Urban Bites California</h1>
              <div class="row me-3">
                  <div class="col-sm-6 ">
                          <div class="row">
                              <div class="col-sm-6 ">
                                    <div class="UB-details d-flex align-items-center justify-content-center">UB</div>
                                    <h1 class="f-14 fw-600">Urban Bites California</h1>
                              </div>
                              <div class="col-sm-6 ">
                                  1
                          </div>
                          </div>
                  </div>

                  <div class="col-sm-6">
                      <div class="row">
                          1
                      </div>

                  </div>

              </div>
          </div>

      </div>
  </div>
</div> -->
<div class="container-fluid merchants-details-main p-0 mb-5" id="merchants-details-page" *ngIf="selectedTab === 4">
  <!-- Integration Component -->
  <div style="background-color: white;" *ngIf="selectedTab === 4">
    <app-employee-support-pin
    [DataParent]="Storedata" ></app-employee-support-pin>
    </div>
</div>
<div class="container-fluid merchants-details-main p-0 mb-5" id="merchants-details-page" *ngIf="selectedTab === 5">
  <!-- <div class="date-picker-wrapper mb-3" style="width: 300px; position: relative;">
    <input 
      type="text" 
      daterangepicker 
      class="datepickerwrap form-control"
      [(ngModel)]="selected"
      [options]="options"
      (ngModelChange)="onDateSelected($event)" 
      style="padding-right: 40px;"
    />
    <img src="assets/images/dashboard-images/bx-calendar.png" class="picker-icon" />
  </div> -->
  <div style="background-color: white;">
    
    <!-- Admin Order Details Component with Date Inputs -->
    <app-admin-order-details
      [isSuperAdmin]="true"
      [isMerchantId]="merchantId"
    ></app-admin-order-details>
  </div>
</div>
<div class="container-fluid merchants-details-main p-0 mb-5" id="merchants-details-page" *ngIf="selectedTab === 6">
 <div style="background-color: white;">
     <app-admin-transactions-details
      [isSuperAdmin]="true"
      [isMerchantId]="merchantId"
    ></app-admin-transactions-details>
  </div>
</div>
